// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --app-color-1: #000814;
    --app-color-2: #001d3d;
    --app-color-3: #003566;
    --app-color-4: #ffd60a;
    --app-color-5: #FFF3CC;
    --text-color-1: #003566;
    --text-color-2:  #0073CF;
    --text-color-3: #66D4FF;
}

.App {
    margin: 0;
    padding: 0;
}

.port-container {
    margin: 0;
    padding: 0;
    width: 100%;
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[":root {\n    --app-color-1: #000814;\n    --app-color-2: #001d3d;\n    --app-color-3: #003566;\n    --app-color-4: #ffd60a;\n    --app-color-5: #FFF3CC;\n    --text-color-1: #003566;\n    --text-color-2:  #0073CF;\n    --text-color-3: #66D4FF;\n}\n\n.App {\n    margin: 0;\n    padding: 0;\n}\n\n.port-container {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
